import { useMemo, useState } from 'react'
import { useHorizontalScroll } from '../../../hooks/packages/useHorizontalScroll';
import { useQueryData } from '../../../hooks/api/useQueryData';
import { useMasterData } from '../../../hooks/api/useMasterData';
import { selectClientSpecialPackageItems, selectSpecialPackageTabs, setSpecialPackageTab } from '../../../features/client/clientSlice';
import { useDispatch, useSelector } from 'react-redux';
import ClientSpecialProduct from '../../layout/Admin/clients/ClientSpecialProduct';
import ClientSpecialMyItems from '../../layout/Admin/clients/ClientSpecialMyItems';
import SpecialPackageModalHeader from '../../common/headers/SpecialPackageModalHeader';
import { clearTypeOfAdditionalModal } from '../../../features/modal/modalSlice';

interface TypeTabList {
    id: number;
    tabId: number;
    tabName: string;
    type: 'items' | 'product';
}

export const tabList: TypeTabList[] = [
    {
        id: 2,
        tabId: 2,
        tabName: "My items",
        type: 'items'
    },
    {
        id: 3,
        tabId: 3,
        tabName: "Product",
        type: 'product'
    },
]

export interface selectedSizeInterface {
    size: string;
    sizeId: number;
};


export default function SpecialPackageModal() {

    const specialPackageItems = useSelector(selectClientSpecialPackageItems)
    const dispatch = useDispatch()
    const [selectedSize, setSelectedSize] = useState<selectedSizeInterface | null>(null)
    const {  productBaseOnCategory, isErrorProductBaseOnCategory, isLoadingProductBaseOnCategory, errorMessageProductBaseOnCategory, } = useQueryData()
    const {
        getAllProduct,
        isFetchingGetAllProduct,
        isLoadingGetAllProduct,
        refetchGetAllProduct,
        isErrorGetAllProduct,
        errorMessageGetAllProduct,

        allPackages,
        isErrorAllPackages,
        isLoadingAllPackages,
        isFetchingAllPackages,
        refetchAllPackages,
        errorMessageAllPackages,

        getCategory,
        isErrorGetCategory,
        isLoadingGetCategory,
        isFetchingGetCategory,
        refetchGetCategory,
        errorMessageGetCategory,
        errorGetCategory,

        getSizes,
        isFetchingGetSizes,
        isLoadingGetSizes,
        refetchGetSizes,
        isErrorGetSizes,
        errorMessageGetSizes,
        errorGetSizes,
    } = useMasterData()

    const sortedProductBaseOnCategory = useMemo(() => {
        return productBaseOnCategory
            ?.slice()
            ?.sort((a, b) => {
                const catA = a.categoryInfo?.categoryName?.toLowerCase() || '';
                const catB = b.categoryInfo?.categoryName?.toLowerCase() || '';
                const catCompare = catA.localeCompare(catB);
                if (catCompare !== 0) return catCompare; // sort by category first
                // same category → sort by size (string)
                const sizeA = a.sizeInfo?.size?.toLowerCase() || '';
                const sizeB = b.sizeInfo?.size?.toLowerCase() || '';
                // Place 'None' or empty sizes last
                if (sizeA === 'none' || sizeA === '') return 1;
                if (sizeB === 'none' || sizeB === '') return -1;
                
                if (sizeA.length !== sizeB.length) {
                    return sizeA.length - sizeB.length;
                }
                return sizeA.localeCompare(sizeB);
        }) ?? []
    }, [ productBaseOnCategory ])

    const filteredProducts = useMemo(() => {
        if(!selectedSize) return
        if (!getAllProduct) return [];

        return getAllProduct.filter(
            product => product.sizeInfo.sizeId === selectedSize.sizeId
        );
    }, [getAllProduct, selectedSize]);

    const { scrollRef, handleMouseDown, handleMouseLeave, handleMouseUp, handleMouseMove, } = useHorizontalScroll();
    const specialPackageTab = useSelector(selectSpecialPackageTabs)

    return (
        <div className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-center z-[100]">
            <div className="relative w-[90%] mx-5 bg-white rounded-lg shadow px-5 flex md:w-[75%] lg:max-w-[45%] lg:mx-auto">
                <div className={`flex flex-col w-full h-[80vh] flex-1 overflow-hidden py-5 space-y-2`}>
                    {/* <div className='flex flex-col w-full'> */}
                            <SpecialPackageModalHeader/>
                            <div className="mt-3">
                                <div
                                    ref={scrollRef}
                                    onMouseDown={handleMouseDown}
                                    onMouseLeave={handleMouseLeave}
                                    onMouseUp={handleMouseUp}
                                    onMouseMove={handleMouseMove}
                                    className="overflow-x-auto flex scrollbar-hide justify-center"
                                >
                                    {tabList.map((tab) => (
                                        <button
                                            key={tab.id}
                                            className={`flex-shrink-0 px-4 py-1 text-sm font-semibold capitalize transition-all duration-200 ${
                                                specialPackageTab === tab.type
                                                ? "border-b-2 border-cbColor text-cbColor font-medium"
                                                : "border-b-2 border-transparent text-black"
                                            }`}
                                            onClick={() => dispatch(setSpecialPackageTab(tab.type))}
                                        >
                                            {
                                                tab.type === 'items'
                                                    ? `${tab.tabName}  ${(specialPackageItems?.length ?? 0) > 0 ? `(${specialPackageItems?.length})` : ""}`
                                                : tab.tabName
                                            }
                                        </button>
                                    ))}
                                </div>
                            </div>
                            {specialPackageTab === 'items' ? (
                                <ClientSpecialMyItems/>
                            ) :(
                                <ClientSpecialProduct
                                    getSizes={getSizes}
                                    selectedSize={selectedSize}
                                    setSelectedSize={setSelectedSize}
                                    filteredProducts={filteredProducts}
                                />
                            )}
                            <div className='w-full grid grid-cols-1 gap-1'>
                                <button onClick={() => dispatch(clearTypeOfAdditionalModal())} className='py-1.5 bg-cbColor text-white text-[12px] rounded'>Done</button>
                            </div>
                    {/* </div> */}
                </div>
            </div>
        </div>
    )
}




{/* <div className="grid grid-cols-1 gap-2">
                                    <div className='grid grid-cols-2 gap-3 p-3'>
                                        {activePackages.map((cat: Package) => {
                                            return (
                                                <div 
                                                    key={cat.packageID}
                                                    // onClick={() => handleClickCategory(cat, cat.categoryID)}
                                                    className='cursor-pointer bg-cbColorSecond rounded flex items-center justify-center'
                                                >
                                                    <div className='flex justify-center p-2 text-[15px] items-center text-center text-cbColorDark font-medium'>
                                                        {cat.packageName}
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div> */}